module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-31.c9d61207.jpg";